<template>
  <div class="navigation-wrapper" :ref="`slide${projectIndex}`">
    <div ref="slider" class="keen-slider">
      <div
        class="keen-slider__slide"
        style="position: relative"
        v-for="(image, index) in getPictures"
        :key="index"
        :style="{
          minWidth: calculateWidth(300, image.aspect_ratio),
          maxWidth: calculateWidth(300, image.aspect_ratio),
        }"
      >
        <AdvancedImage
          v-if="!imageLoadError[index] && imageLoaded[index] && image.source == 'cloudinary'"
          :cldImg="this.cldImage(image.public_id)"
          @error="onImageLoadError(index)"
          @load="onImageLoad(index)"
        />
        <img
          v-else-if="!imageLoadError[index] && imageLoaded[index]"
          :src="image.secure_url" />
        <div v-else class="card">
          <div class="card__image"></div>
          <div class="card__content">
            <h2></h2>
            <p></p>
          </div>
        </div>
        <p
          v-if="image.project_stage_id && completed && image.public_id"
          class="splide-p"
          style="font-size: 12px"
        >
          {{ getText(image.project_stage_id) }}
        </p>
      </div>
    </div>
  </div>
  <div v-if="slider" class="dots">
    <button
      v-for="(_slide, idx) in dotHelper"
      @click="slider.moveToIdx(idx)"
      :class="{ dot: true, active: current === idx }"
      :key="idx"
    ></button>
  </div>
</template>

<script>
import 'keen-slider/keen-slider.min.css'
import KeenSlider from 'keen-slider'
import { AdvancedImage } from '@cloudinary/vue'
import { ApiCloudinary } from '../../../../mixins/apiCloudinary'
const animation = { duration: 20000, easing: (t) => t }

export default {
  props: {
    pictures: Array,
    stages: Array,
    completed: Boolean,
    inTheViewPort: Boolean,
    has_many: Boolean,
    projectIndex: Number,
  },
  components: {
    AdvancedImage,
  },
  mixins: [ApiCloudinary],
  data() {
    return {
      current: 0,
      slider: null,
      currPictures: null,
      imageLoadError: [],
      imageLoaded: [],
    }
  },
  mounted() {
    this.initKeenSlider()
    if (!this.has_many) {
      this.slider.animator.stop()
    }
    this.currPictures.forEach(async (image, index) => {
      await this.cldImage(image.public_id)
      setTimeout(() => {
        this.imageLoaded[index] = true
      }, 1000)
    })
  },
  beforeDestroy() {
    if (this.slider) this.slider.destroy()
  },
  methods: {
    initKeenSlider() {
      this.slider = new KeenSlider(this.$refs.slider, {
        loop: true,
        mode: 'snap',
        renderMode: 'performance',
        rtl: false,
        slides: { perView: 'auto', spacing: 15 },
        initial: this.current,
        slideChanged: (s) => {
          this.current = s.track.details.rel
        },
        created(s) {
          s.moveToIdx(5, true, animation)
        },
        updated(s) {
          s.moveToIdx(s.track.details.abs + 5, true, animation)
        },
        animationEnded(s) {
          s.moveToIdx(s.track.details.abs + 5, true, animation)
        },
      })
    },
    getText(id) {
      return this.stages.find((stage) => stage.id === id)?.picture_caption
    },
    calculateWidth(height, aspectRatio) {
      const width = height * aspectRatio
      return `${Math.floor(width)}px`
    },
    onImageLoadError(index) {
      this.imageLoadError[index] = true
    },
    onImageLoad(index) {
      this.imageLoaded[index] = true
    },
  },
  computed: {
    dotHelper() {
      return this.slider
        ? [...Array(this.slider.track.details.slides.length).keys()]
        : []
    },
    getPictures() {
      return this.currPictures.filter((i) => i.public_id)
    },
    handle() {
      this.slider.animator.stop()
    },
  },
  created() {
    this.currPictures = JSON.parse(JSON.stringify(this.pictures))
  },
  watch: {
    inTheViewPort: {
      immediate: true,
      handler() {
        if (this.slider) {
          if (this.inTheViewPort) {
            this.initKeenSlider()
          } else {
            this.slider.animator.stop()
          }
        }
      },
    },
  },
}
</script>

<style>
.dots {
  display: flex;
  padding: 10px 0;
  justify-content: center;
  overflow-x: auto;
}
.dot {
  border: none;
  width: 10px;
  height: 10px;
  background: #c5c5c5;
  border-radius: 50%;
  margin: 0 5px;
  padding: 5px;
  cursor: pointer;
}
.dot:focus {
  outline: none;
}
.dot.active {
  background: #000;
}

.splide-p {
  font-size: 12px;
  position: absolute;
  width: 100%;
  bottom: 0px;
  margin: 0;
  padding: 10px;
  padding-left: 5px;
  background: #4c4f4d;
  color: white;
  opacity: 0.7;
  font-weight: bold;
}

.card {
  width: 100%;
  min-height: 300px;
  height: 100%;
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
}
.card__content {
  padding: 20px;
}

@keyframes shine {
  to {
    background-position-x: -200%;
  }
}

.card .card__image,
.card h2,
.card p {
  background: linear-gradient(110deg, #ececec 8%, #f5f5f5 18%, #ececec 33%);
  border-radius: 5px;
  background-size: 200% 100%;
  animation: 1s shine linear infinite;
}
.card__image {
  height: 100%;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}

.card__content p {
  /* height: 70px; */
  width: 80%;
}
</style>
